<template>
  <div class="education">
    <div class="" v-on-scroll="{animation: 'header'}">
      <h3 class="wow">Why Gv Learning ?</h3>
      <hr class="wow">
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-7">
          <div class="wow" v-on-scroll="{animation: 'info'}">
            <h4>01</h4>
            <h5>Engage with ease</h5>
            <p>Thoughtfully designed with admins and learners in mind, GV Learning aims to make learning a simple,
              engaging experience for all</p>
          </div>

          <div class="wow" v-on-scroll="{animation: 'info'}">
            <h4>02</h4>
            <h5>Scalable training delivery</h5>
            <p>From automating everyday tasks to ensuring critical training courses run smoothly, GV Learning has what
              you need to efficiently scale training programs</p>
          </div>

          <div class="wow" v-on-scroll="{animation: 'info'}">
            <h4>03</h4>
            <h5>Reporting & Support</h5>
            <p>The data you need, right when you need it with out-of-the-box reports to calculate training ROI. And 24/7
              support from our friendly and knowledgeable Technical Support Reps grantee to provide the best customer
              support in the business.</p>
          </div>

          <div class="wow" v-on-scroll="{animation: 'info'}">
            <h4>04</h4>
            <h5>Quick to set-up</h5>
            <p>With our easy-to-use platform and skilled support, you may launch your profile anywhere from one week to
              one year, leaving the "Go-live" date up to you.</p>
          </div>

        </div>
        <div class="col-md-5">
          <div class="wow" v-on-scroll="{animation: 'img-cont'}">
            <img
                src="@/assets/gvLearning/img/vertical-shot-contemplative-thoughtful-dark-skinned-man-keeps-hand-chin-looks-thoughtfully-upwards-1.png"
                alt="learning photo">
          </div>

        </div>
      </div>

    </div>

  </div>
</template>


<style lang="scss" scoped>
@use "sass:math";
@import "~@/assets/gvLearning/styles.scss";
@import "~@/assets/gvLearning/education.scss";

.education {
  background: #E2E2E2;
  padding: 65px 0px 0 80px;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 65px 0px 0 18px;
  }

  .header {
    margin-left: 20px;

    h3 {
      color: #000;
    }

    hr {
      background-color: #000;
    }
  }

  .content {
    padding-left: 20px;

    .row {
      @media (min-width: $width1) and (max-width: $width2) {
        flex-direction: column-reverse;
      }

      .col-md-7 {
        @media (min-width: $width1) and (max-width: $width2) {
          padding-right: 41px;
        }
        @for $i from 1 through 4 {
          .info:nth-child(#{$i}) {
            animation-duration: math.div($i, 2) + 0.5s;
          }
        }

        .info {
          text-align: left;
          border-bottom: 1px solid rgba(20, 20, 20, 0.4);
          margin-bottom: 24px;
          animation: bounceInRight;

          h4 {

            text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
            color: #E2E2E2;
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 44px;
            @media (min-width: $width1) and (max-width: $width2) {
              font-size: 38px;

            }

          }

          h5 {
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 30px;
            line-height: 107.19%;
            text-align: justify;
            color: #00C167;
            margin-bottom: 12px;
            @media (min-width: $width1) and (max-width: $width2) {
              font-size: 24px;

            }

          }

          p {
            font-family: Roboto;
            font-style: normal;
            font-weight: 300;
            font-size: 18px;
            line-height: 131%;
            color: #141414;
            padding-right: 34px;
            margin-bottom: 20px;
            @media (min-width: $width1) and (max-width: $width2) {
              font-size: 14px;

            }
          }
        }

        .info:last-of-type {
          border: none;
          padding-bottom: 40px;
        }

      }

      .img-cont {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        animation: bounceInLeft;
        animation-duration: 2s;
        @media (min-width: $width1) and (max-width: $width2) {
          height: 530px;
          margin-bottom: 55px;

        }

        img {
          width: 150%;
          height: 145%;
          position: absolute;
          right: 0;
          bottom: 0;
          @media (min-width: $width1) and (max-width: $width2) {
            right: -28px;

          }
        }
      }

    }

  }

}
</style>
